import RoutesMap from "../../route_control/RouteControl"
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import {
    UserLogin
} from "../../pages/user"

export const AuthRouteImport = {
    RoutesMap,
    useNavigate,
    Swal,
    UserLogin,
}